import moduleConfig from './module-config';
import netsCallfrom from './nets-callfrom';

export default angular
  .module('app.settings-callfrom', [])
  .config(['$stateProvider', moduleConfig])
  .component('netsCallfrom', netsCallfrom);
